"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNIT_MAP = void 0;
exports.UNIT_MAP = {
    'ft3/m': 'ft3m',
    'L/m': 'Lmin',
    'L/s': 'Lsec',
    'kg/cm2': 'kgcm2',
    ft: 'ftH2O',
    m: 'mH2O',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidW5pdE1hcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy91bml0TWFwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsUUFBUSxHQUEyQjtJQUM1QyxPQUFPLEVBQUUsTUFBTTtJQUNmLEtBQUssRUFBRSxNQUFNO0lBQ2IsS0FBSyxFQUFFLE1BQU07SUFDYixRQUFRLEVBQUUsT0FBTztJQUNqQixFQUFFLEVBQUUsT0FBTztJQUNYLENBQUMsRUFBRSxNQUFNO0NBQ1osQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBVTklUX01BUDogUmVjb3JkPHN0cmluZywgc3RyaW5nPiA9IHtcbiAgICAnZnQzL20nOiAnZnQzbScsXG4gICAgJ0wvbSc6ICdMbWluJyxcbiAgICAnTC9zJzogJ0xzZWMnLFxuICAgICdrZy9jbTInOiAna2djbTInLFxuICAgIGZ0OiAnZnRIMk8nLFxuICAgIG06ICdtSDJPJyxcbn07XG4iXX0=